import { Keyboard } from '@capacitor/keyboard'
import { isNativeApp } from './native-session.js'

/** Navigation ends the old form's input session, including native autofill suggestions. */
export function dismissFormFocus(doc: Document): void {
  const active = doc.activeElement as HTMLElement | null
  if (
    active?.matches('input, textarea, select, [contenteditable]:not([contenteditable="false"])')
  ) {
    active.blur()
  }
  if (isNativeApp()) void Keyboard.hide().catch(() => undefined)
}
